import { useEffect, useState } from 'react';

import { TextField } from '@backstage/ui';

import {
  DialogCompositeBui,
  extractLastNameComponent,
} from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';
import { useUpdateAttachment } from '@spotify/plugin-confidence-attachments-react';

interface RenameArtifactDialogProps {
  artifact: AttachmentFragment;
  resolvedDisplayName?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const RenameArtifactDialog = ({
  artifact,
  resolvedDisplayName,
  open,
  onOpenChange,
}: RenameArtifactDialogProps) => {
  const currentName =
    artifact.displayName ||
    resolvedDisplayName ||
    extractLastNameComponent(artifact.uri);
  const [displayName, setDisplayName] = useState(currentName);

  useEffect(() => {
    if (open) {
      setDisplayName(currentName);
    }
  }, [open, currentName]);

  const { updateAttachment } = useUpdateAttachment({
    onError: 'post-alert',
  });

  const handleSubmit = async () => {
    await updateAttachment({ name: artifact.name, displayName }, [
      'displayName',
    ]);
  };

  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <DialogCompositeBui.Root open={open} onClose={handleClose} width="sm">
      <DialogCompositeBui.Content component="form" onSubmit={handleSubmit}>
        <DialogCompositeBui.Header>
          <DialogCompositeBui.Title>Rename</DialogCompositeBui.Title>
          <DialogCompositeBui.CloseButton />
        </DialogCompositeBui.Header>
        <DialogCompositeBui.Body>
          <DialogCompositeBui.SubmitError />
          <TextField
            label="Name"
            value={displayName}
            onChange={setDisplayName}
            isRequired
            autoFocus // eslint-disable-line jsx-a11y/no-autofocus
          />
        </DialogCompositeBui.Body>
        <DialogCompositeBui.Actions>
          <DialogCompositeBui.Actions.Cancel />
          <DialogCompositeBui.Actions.Submit>
            Save
          </DialogCompositeBui.Actions.Submit>
        </DialogCompositeBui.Actions>
      </DialogCompositeBui.Content>
    </DialogCompositeBui.Root>
  );
};
